import { useUnit } from 'effector-react'
import { $gateways, $total, getClientGatewaysFx } from './model'

export const useClientGatewayList = () => {
  const gateways = useUnit($gateways)
  const total = useUnit($total)
  const loading = useUnit(getClientGatewaysFx.pending)

  return { gateways, total, loading }
}
